import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 84,
	height: 83,
	viewBox: "0 0 84 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.9 71.0605C63.9608 71.0605 63.1924 70.2964 63.1924 69.3626V61.8659C63.1924 60.9321 63.9608 60.168 64.9 60.168H72.35C73.2892 60.168 74.0576 60.9321 74.0576 61.8659V69.3626C74.0576 70.2964 73.2892 71.0605 72.35 71.0605H64.9Z",
			fill: "#F4F8FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.074 10.3359H34.408C32.0032 10.3359 30.0537 12.2854 30.0537 14.6902V48.4624C30.0537 50.8672 32.0032 52.8167 34.408 52.8167H68.074C70.4788 52.8167 72.4283 50.8672 72.4283 48.4624V14.6902C72.4283 12.2854 70.4788 10.3359 68.074 10.3359Z",
			fill: "#BABABA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.0087 25.1979C40.8085 25.1979 40.6465 24.9424 40.6465 24.6267V22.3421C40.6465 22.027 40.8085 21.7715 41.0087 21.7715H51.1495C51.3497 21.7715 51.5118 22.027 51.5118 22.3421V24.6267C51.5118 24.9424 51.3497 25.1979 51.1495 25.1979H41.0087Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M66.9041 33.3678H41.552C41.0515 33.3678 40.6465 33.1123 40.6465 32.7966V30.512C40.6465 30.1969 41.0515 29.9414 41.552 29.9414H66.9041C67.4046 29.9414 67.8097 30.1969 67.8097 30.512V32.7966C67.8097 33.1123 67.4046 33.3678 66.9041 33.3678Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.3709 41.5377C40.9705 41.5377 40.6465 41.2822 40.6465 40.9666V38.682C40.6465 38.3668 40.9705 38.1113 41.3709 38.1113H61.6526C62.053 38.1113 62.377 38.3668 62.377 38.682V40.9666C62.377 41.2822 62.053 41.5377 61.6526 41.5377H41.3709Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.8738 29.6699H16.2078C13.803 29.6699 11.8535 31.6194 11.8535 34.0242V67.7964C11.8535 70.2012 13.803 72.1506 16.2078 72.1506H49.8738C52.2786 72.1506 54.2281 70.2012 54.2281 67.7964V34.0242C54.2281 31.6194 52.2786 29.6699 49.8738 29.6699Z",
			fill: "#DEDEDE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2078 29.6699H49.8738C52.2786 29.6699 54.2281 31.6194 54.2281 34.0242V39.6781H11.8535V34.0242C11.8535 31.6194 13.803 29.6699 16.2078 29.6699Z",
			fill: "#E1373B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.1652 57.8622H38.2415L37.9141 57.5465C39.06 56.2135 39.7499 54.483 39.7499 52.6004C39.7499 48.4026 36.3472 45 32.1495 45C28.1505 45 24.8765 48.0869 24.5842 52.0158H26.9461C27.2385 49.3848 29.4367 47.3386 32.1495 47.3386C35.061 47.3386 37.4113 49.6889 37.4113 52.6004C37.4113 55.5119 35.061 57.8622 32.1495 57.8622C31.9507 57.8622 31.7636 57.8271 31.5648 57.8037V60.1657C31.7636 60.1891 31.9507 60.2008 32.1495 60.2008C34.032 60.2008 35.7626 59.5109 37.0956 58.365L37.4113 58.6924V59.6161L43.2578 65.4509L45 63.7087L39.1652 57.8622Z",
			fill: "black",
			fillOpacity: .54
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6065 54.1442L25.7183 57.0324L22.8302 54.1442L22 54.9744L24.8882 57.8626L22 60.7507L22.8302 61.5809L25.7183 58.6928L28.6065 61.5809L29.4367 60.7507L26.5485 57.8626L29.4367 54.9744L28.6065 54.1442Z",
			fill: "black",
			fillOpacity: .54
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .3,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4.64927 8.76665C5.37956 9.49695 6.56362 9.49692 7.29395 8.7666C8.02427 8.03628 8.02429 6.85222 7.294 6.12192C6.5637 5.39163 5.37964 5.39165 4.64932 6.12197C3.919 6.8523 3.91897 8.03636 4.64927 8.76665Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.3818 24.7521C21.1121 25.4824 22.2962 25.4824 23.0265 24.7521C23.7568 24.0218 23.7568 22.8378 23.0265 22.1075C22.2962 21.3772 21.1121 21.3772 20.3818 22.1075C19.6516 22.8378 19.6516 24.0218 20.3818 24.7521Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.92292 12.7844C11.8075 10.8998 14.8631 10.8997 16.7477 12.7843C18.6323 14.6689 18.6323 17.7245 16.7477 19.6091C14.863 21.4938 11.8075 21.4938 9.92287 19.6092C8.03827 17.7246 8.03829 14.669 9.92292 12.7844Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.6285 13.905C27.6285 14.9378 26.7913 15.775 25.7585 15.775C24.7257 15.775 23.8884 14.9378 23.8884 13.905C23.8884 12.8722 24.7257 12.0349 25.7585 12.0349C26.7913 12.0349 27.6285 12.8722 27.6285 13.905Z",
					fill: "#656565"
				})
			]
		})
	]
});
export default SvgPageNotFound;
